import React from 'react';
import PropTypes from 'prop-types';
import PictionJS from 'piction-js';
import ReactAudioPlayer from 'react-audio-player';
import Loader from '../ui/Loader';
import appConfig from '../../appConfig';
import { disableRightClick } from '../../utils/uiUtils';

function UMOMediaView({ umo }) {
  let media;
  const webQualityType = umo.type || umo.webQuality.type;
  const webQualityURL = umo.webQuality ? umo.webQuality.url : umo.thumbnail.url;

  if (umo.thumbnail && umo.thumbnail._data.$.restricted === 'T') {
    media = (
      <img
        className={'umo-media-view__image'}
        alt={umo.name}
        src={'./images/thumb/restricted.jpg'}
        onContextMenu={disableRightClick}
      />
    );
  } else {
    switch (webQualityType) {
      case 'VIDEO':
        media = (
          <video className="umo-media-view__video" playsInline autoPlay controls loop poster="">
            <source src={webQualityURL} />
            <p>Video cannot be played in this browser</p>
          </video>
          /*
          <PlyrComponent vidSrc={webQualityURL} />

        <VideoPlayer
            controls
            autoplay
            src={webQualityURL}
            type={webQualityType}
            poster=""
            loop
          />
  */
      );
        break;
      case 'AUDIO':
        media = (
          <ReactAudioPlayer
            className="umo-media-view__audio"
            src={webQualityURL}
            autoPlay controls loop
          />
      );
        break;
      case 'DOCUMENT':
      case 'HTML': {
        if (umo.originalList.all[0]) {
          const host = umo.originalList.all[0]._data.$.h.includes('/wds/') ?
          appConfig.cardURL : appConfig.hostURL;
          media = (
            <iframe
              className="umo-media-view__html"
              src={host + umo.originalList.all[0]._data.$.h}
            />
        );
        } else { // in case no download rules exist for this type of media
          media = (
            <img
              className="umo-media-view__image"
              alt={umo.name}
              src={webQualityURL}
              loader={<Loader />}
              onContextMenu={disableRightClick}
            />
        );
        }
        break;
      }
      case 'RELATIONAL':
        media = (
          <img
            className={'umo-media-view__image'}
            alt={umo.name}
            src={'./images/thumb/relational.gif'}
            onContextMenu={disableRightClick}
          />
        );
        break;
      case 'PHOTO': {
        const original = umo.originalList.all[0] ? umo.originalList.all.filter(i => i.index === '1')[0] : null;
        // display original for gifs
        const photoUrl = original && original.mimeType.includes('gif') ? original.url : webQualityURL;
        media = (<img
          className="umo-media-view__image"
          alt={umo.name}
          src={photoUrl}
          onContextMenu={disableRightClick}
        />);
        break;
      }
      default:
        media = (
          <img
            className="umo-media-view__image"
            alt={umo.name}
            src={webQualityURL}
            onContextMenu={disableRightClick}
          />
      );
        break;
    }
  }

  return (
    <div className="umo-media-view">
      { media }
    </div>
  );
}

UMOMediaView.propTypes = {
  umo: PropTypes.instanceOf(PictionJS.UMO),
};

export default UMOMediaView;



// WEBPACK FOOTER //
// ./src/js/components/UMOMediaView/index.jsx